<template>
    <b-container fluid>
        <b-row row wrap>
            <b-col>
                <b-table
                    responsive
                    outlined
                    striped
                    :items="theItems"
                    :fields="fields"
                >
                    <template slot="actions" slot-scope="{ item }">
                        <b-btn
                            size="sm"
                            variant="danger"
                            @click="deleteItem(item)"
                            ><i class="fa fa-trash"></i
                        ></b-btn>
                    </template>
                </b-table>
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
import roundsRepository from "@repositories/rounds.repository";
export default {
    props: {
        items: {
            type: Array,
            default: () => []
        }
    },
    data: () => ({
        fields: [
            {
                key: "order",
                label: "Orden"
            },
            {
                key: "name",
                label: "Item"
            },
            {
                key: "description",
                label: "Descripción"
            },
            {
                key: "actions",
                label: "Acciones"
            }
        ]
    }),
    computed: {
        theItems() {
            return this.items.sort((a, b) => a.order - b.order);
        }
    },
    methods: {
        async deleteItem(item) {
            const rr = { ...roundsRepository };

            try {
                const data = await rr.removeChecklistItem(item.id);

                if (data) {
                    const index = this.items.findIndex(x => x.id === item.id);
                    this.items.splice(index, 1);
                }
            } catch (err) {}
        }
    }
};
</script>
